import { Routes, Route, Navigate } from 'react-router-dom';
import TeacherPanel from '../views/prowadzacy/TeacherPanel';
import TermsUp from '../views/prowadzacy/TermsUp';
import TermsFinish from '../views/prowadzacy/TermsFinish';
import ExamTerm from '../views/prowadzacy/ExamTerm';

import ExamBuilder from '../views/prowadzacy/ExamBuilder';
import Exams from '../views/prowadzacy/Exams';
import ExamDetails from '../views/prowadzacy/ExamDetails';
import ExamTermManager from '../views/prowadzacy/ExamTermManager';
import ExamTerms from '../views/prowadzacy/ExamTerms';
import GroupList from '../views/prowadzacy/GroupList';
import GroupDetailsPage from '../views/prowadzacy/GroupDetailsPage';
import AttemptPlayer from '../views/prowadzacy/AttemptPlayer';
import Attempt from '../views/prowadzacy/Attempt';
import AttemptGrade from '../views/prowadzacy/AttemptGrade';
import AttemptFlags from '../views/prowadzacy/AttemptFlags';

function TeacherRouter({ user }) {
    return (
        <Routes>
            <Route path="/" element={<TeacherPanel user={user} />} />
            <Route path="terminy/zaplanowane" element={<TermsUp user={user} />} />
            <Route path="terminy/koniec" element={<TermsFinish user={user} />} />
            <Route path="termin/:id" element={<ExamTerm user={user} />} />
            <Route path="termin/:id/przebieg" element={<ExamTermManager user={user} />} />
            <Route path="attempt/:id" element={<Attempt user={user} />} />
            <Route path="attempt/:id/ocena" element={<AttemptGrade user={user} />} />
            <Route path="attempt/:id/player" element={<AttemptPlayer user={user} />} />
            <Route path="attempt/:id/flagi" element={<AttemptFlags user={user} />} />
            <Route path="egzaminy" element={<Exams user={user} />} />
            <Route path="egzamin/:id" element={<ExamDetails user={user} />} />
            <Route path="egzamin/:id/builder" element={<ExamBuilder user={user} />} />
            <Route path="egzamin/:id/terminy" element={<ExamTerms user={user} />} />
            <Route path="grupy" element={<GroupList user={user} />} />
            <Route path="grupa/:id" element={<GroupDetailsPage user={user} />} />
            <Route path="*" element={<Navigate to="/prowadzacy" />} />
        </Routes>
    );
}

export default TeacherRouter;
